$(function() {

  console.log($('#unsubscribe').data('id'));

  $('#unsubscribe').on('click', function(e) {
    e.preventDefault(); // デフォルトのクリック動作を無効化

    const customer_id = $(this).data('id');

    let formData = new FormData();
    formData.append("entry.1090432177", customer_id);

    console.log(formData.get("entry.1090432177"));


    const data = `entry.1090432177=${customer_id}`;


    $.ajax({
      url: "https://docs.google.com/forms/u/0/d/e/1FAIpQLScBbqMig-T44pEBwfjazqlpCBby5Le1RsOHp7I4e_85s4TygQ/formResponse", //Google Form の action属性値
      data: data,
      type: "POST",
      dataType: "xml",
      statusCode: {
        0: function () {
          console.log('送信完了');
          alert('メルマガ購読を解除しました');
          location.reload();
          location.href = '/account#magazine';
        },
        200: function () {
          console.error('送信エラー');
          alert('解除の際にエラーが発生しました。お問合せフォームよりお問い合わせください。');
          location.reload();
        }
      }
    });

  });
});